
import React from 'react';
import BlockchainTxns from './components/BlockchainTxns';

function App() {

  return <>

    <BlockchainTxns />
    
  </>

}

export default App